const colorizer = () => '#' + Math.floor(Math.random() * 16777215).toString(16);

function getTheWordCoordinate(words, word) {
  const initial = words.indexOf(word);
  const wordLength = word.length;
  return [initial, initial + wordLength - 1];
}

function makeid(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function getWordsIndexCoordinate(words, start, end) {
  let targetIndex = 0;
  if (start !== 0) {
    targetIndex = words.slice(0, start).trim().split(' ').length;
  }
  const numberOfWord = words.slice(start, end).trim().split(' ').length;

  return [targetIndex, targetIndex + numberOfWord - 1];
}

function joinArrayRange(array, start, end, color, normalize, index = '') {
  let result = '';
  const joined = array.slice(start, end + 1).join(' ');
  array.splice(start, end - start + 1, `<span style="background: ${color}" id="boldit${index}">${joined}</span>`, ...[...Array(end - start).fill('<xxx>')]);
  
  if (normalize) {
    result = array.filter(item => item !== '<xxx>').join(' ');
  } else {
    result = array.join(' ');
  }

  return result;
}

// hightlightIt(text) {
//   if (!text) {
//     return 'No Text';
//   }

//   let str = text
//   const data = this.sentences[this.currentIndex].elements.filter(item => item.id === this.currentEditting)[0];
//   const entity_concerned = Array.isArray(data.main_words) ? data.main_words[0] : data.main_words;

//   str = str.replace(new RegExp("\\b" + entity_concerned + "\\b" + "(?![^<]*</span>)"), match => {
//     return `<span class="bg-red-300">${match}</span>`;
//   });

//   for (let sequences of data.sequences) {
//     const sequence = sequences.join(' ')
//     str = str.replace(new RegExp("\\b" + sequence + "\\b" + "(?![^<]*</span>)"), match => {
//       return `<span class="bg-teal-300">${match}</span>`;
//     });
//   }

//   this.currentSentence = str;
// },

export { colorizer, getTheWordCoordinate, makeid, getWordsIndexCoordinate, joinArrayRange };
